var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBespoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.05 93.38",
    style: {
      enableBackground: "new 0 0 90.05 93.38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.5623,
    y1: 15.1811,
    x2: 51.5623,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.35,20.95L70.78,6.38c-0.3-0.3-0.71-0.47-1.13-0.47H22.11c-2.65,0-4.8,2.15-4.8,4.8v1.12h3.2v-1.12 c0-0.88,0.72-1.6,1.6-1.6h45.95v9.77c0,2.65,2.15,4.8,4.8,4.8h9.77v59.39c0,0.88-0.72,1.6-1.6,1.6H22.11 c-0.88,0-1.6-0.72-1.6-1.6V69.36c0-0.88-0.72-1.6-1.6-1.6c-0.88,0-1.6,0.72-1.6,1.6v13.71c0,2.65,2.15,4.8,4.8,4.8h58.91 c2.65,0,4.8-2.15,4.8-4.8v-61C85.82,21.65,85.65,21.25,85.35,20.95z M72.85,20.48c-0.88,0-1.6-0.72-1.6-1.6v-7.5l9.1,9.1H72.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.8546,
    y1: 20.4803,
    x2: 72.8546,
    y2: 20.4803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.85,20.48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9035,
    y1: 15.1811,
    x2: 18.9035,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.04,62.41c-0.3-0.3-0.71-0.47-1.13-0.47c-0.42,0-0.83,0.17-1.13,0.47c-0.3,0.3-0.47,0.71-0.47,1.13 c0,0.42,0.17,0.83,0.47,1.13c0.3,0.3,0.71,0.47,1.13,0.47c0.42,0,0.83-0.17,1.13-0.47c0.3-0.3,0.47-0.71,0.47-1.13 C20.5,63.12,20.33,62.71,20.04,62.41L20.04,62.41z M20.04,62.41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.6419,
    y1: 15.1811,
    x2: 53.6419,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.99,56.44c-2.65,0-4.8,2.15-4.8,4.8c0,0.66,0.14,1.3,0.38,1.87l-9.22,9.22c-0.63-0.31-1.34-0.48-2.1-0.48 c-0.73,0-1.43,0.17-2.05,0.46l-6.12-6.13c0.21-0.54,0.33-1.13,0.33-1.75c0-2.65-2.15-4.8-4.8-4.8c-2.65,0-4.8,2.15-4.8,4.8 c0,0.72,0.16,1.4,0.44,2.01l-5.87,5.87c-0.63-0.3-1.33-0.47-2.06-0.47c-2.65,0-4.8,2.15-4.8,4.8c0,2.65,2.15,4.8,4.8,4.8 c2.65,0,4.8-2.15,4.8-4.8c0-0.74-0.17-1.45-0.47-2.07l5.84-5.84c0.64,0.32,1.36,0.5,2.13,0.5c0.86,0,1.67-0.23,2.37-0.63 l5.95,5.95c-0.31,0.63-0.48,1.34-0.48,2.09c0,2.65,2.15,4.8,4.8,4.8c2.65,0,4.8-2.15,4.8-4.8c0-0.73-0.16-1.42-0.46-2.04 l9.14-9.14c0.67,0.36,1.44,0.57,2.26,0.57c2.65,0,4.8-2.15,4.8-4.8S76.64,56.44,73.99,56.44L73.99,56.44z M33.3,78.26 c-0.88,0-1.6-0.72-1.6-1.6c0-0.88,0.72-1.6,1.6-1.6c0.43,0,0.82,0.17,1.11,0.45c0.01,0.01,0.01,0.01,0.02,0.02 c0.01,0.01,0.02,0.01,0.02,0.02c0.28,0.29,0.45,0.68,0.45,1.11C34.9,77.55,34.18,78.26,33.3,78.26L33.3,78.26z M45.6,66.04 c-0.88,0-1.6-0.72-1.6-1.6c0-0.88,0.72-1.6,1.6-1.6c0.88,0,1.6,0.72,1.6,1.6C47.2,65.33,46.48,66.04,45.6,66.04L45.6,66.04z  M58.24,78.26c-0.88,0-1.6-0.72-1.6-1.6s0.72-1.6,1.6-1.6c0.88,0,1.6,0.72,1.6,1.6S59.13,78.26,58.24,78.26L58.24,78.26z  M73.99,62.84c-0.88,0-1.6-0.72-1.6-1.6c0-0.88,0.72-1.6,1.6-1.6c0.88,0,1.6,0.72,1.6,1.6C75.59,62.12,74.87,62.84,73.99,62.84 L73.99,62.84z M73.99,62.84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8894,
    y1: 15.1811,
    x2: 73.8894,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.29,38.78v8.45c0,0.88,0.72,1.6,1.6,1.6c0.88,0,1.6-0.72,1.6-1.6v-8.45c0-0.88-0.72-1.6-1.6-1.6 C73.01,37.18,72.29,37.89,72.29,38.78L72.29,38.78z M72.29,38.78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2742,
    y1: 15.1811,
    x2: 52.2742,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.67,38.78v8.45c0,0.88,0.72,1.6,1.6,1.6c0.88,0,1.6-0.72,1.6-1.6v-8.45c0-0.88-0.72-1.6-1.6-1.6 C51.39,37.18,50.67,37.89,50.67,38.78L50.67,38.78z M50.67,38.78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.1856,
    y1: 15.1811,
    x2: 59.1856,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.58,27.67v19.56c0,0.88,0.72,1.6,1.6,1.6c0.88,0,1.6-0.72,1.6-1.6V27.67c0-0.88-0.72-1.6-1.6-1.6 C58.3,26.07,57.58,26.79,57.58,27.67L57.58,27.67z M57.58,27.67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.205,
    y1: 15.1811,
    x2: 66.205,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M64.6,32.16v15.4c0,0.7,0.72,1.26,1.6,1.26c0.88,0,1.6-0.56,1.6-1.26v-15.4c0-0.7-0.72-1.26-1.6-1.26 C65.32,30.9,64.6,31.47,64.6,32.16L64.6,32.16z M64.6,32.16"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1159,
    y1: 15.1811,
    x2: 24.1159,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.5,14.74C8.15,17.26,0.98,28.61,3.53,40.04c0.69,3.08,2.06,5.99,3.98,8.46c-0.18,2.16-1.29,4.15-3.05,5.43 c-0.99,0.72-1.21,2.11-0.49,3.1c0.14,0.19,0.3,0.35,0.48,0.48c2.31,1.7,5.23,2.33,8.02,1.7c2.21-0.49,4.16-1.72,5.55-3.46 c3.47,1.07,7.14,1.22,10.72,0.42C40.08,53.65,47.25,42.3,44.7,30.87S30.86,12.21,19.5,14.74z M27.49,53.38 c-3.6,0.66-7.27,0.22-10.6-1.28l0,0c-1.12-0.51-2.47-0.08-3.08,1.01c-0.87,1.53-2.35,2.59-4.07,2.91 c-0.67,0.12-1.35,0.13-2.02,0.02c1.74-2.18,2.75-4.9,2.82-7.75c0.02-0.6-0.19-1.15-0.54-1.58c-1.8-2.3-3.04-5.06-3.58-7.96 C4.61,28.87,11.1,19.37,20.9,17.57c9.79-1.8,19.24,4.76,21.06,14.64C43.77,42.08,37.29,51.58,27.49,53.38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.3809,
    y1: 15.1811,
    x2: 19.3809,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23.61,41.86h-8.45c-0.88,0-1.6,0.72-1.6,1.6c0,0.88,0.72,1.6,1.6,1.6h8.45c0.88,0,1.6-0.72,1.6-1.6 C25.21,42.58,24.49,41.86,23.61,41.86L23.61,41.86z M23.61,41.86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8947,
    y1: 15.1811,
    x2: 30.8947,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M32.03,42.33c-0.3-0.3-0.71-0.47-1.13-0.47c-0.42,0-0.83,0.17-1.13,0.47c-0.3,0.3-0.47,0.71-0.47,1.13 c0,0.42,0.17,0.83,0.47,1.13c0.3,0.3,0.71,0.47,1.13,0.47c0.42,0,0.83-0.17,1.13-0.47c0.3-0.3,0.47-0.71,0.47-1.13 C32.5,43.04,32.32,42.63,32.03,42.33L32.03,42.33z M32.03,42.33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9342,
    y1: 15.1811,
    x2: 24.9342,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M34.71,26.5H15.16c-0.88,0-1.6,0.72-1.6,1.6s0.72,1.6,1.6,1.6h19.56c0.88,0,1.6-0.72,1.6-1.6 S35.6,26.5,34.71,26.5L34.71,26.5z M34.71,26.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9342,
    y1: 15.1811,
    x2: 24.9342,
    y2: 87.0592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6344,
    style: {
      stopColor: "#73307a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#73307a"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M34.71,34.18H15.16c-0.88,0-1.6,0.72-1.6,1.6c0,0.88,0.72,1.6,1.6,1.6h19.56c0.88,0,1.6-0.72,1.6-1.6 C36.31,34.9,35.6,34.18,34.71,34.18L34.71,34.18z M34.71,34.18"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBespoke);
export default __webpack_public_path__ + "static/media/bespoke.d2130f2b.svg";
export { ForwardRef as ReactComponent };